import React, { useEffect, useState } from 'react';
import { Box, Paper } from '@material-ui/core';
import { myContainerStyle } from '../../../configs/ui/constant';
import Loading from '../../../components/Loading/Loading.jsx';
import jwtDecode from 'jwt-decode';
import Manual from '../../../components/Manual/Manual';
import { useOktaAuth } from '@okta/okta-react';

export default function DashBoard() {
   //Mock-UP GetData============================
   const [loading, setLoading] = useState(false);
   const [isSuperAdmin, setIsSuperAdmin] = useState(false);
   useEffect(() => {
      setTimeout(() => {
         setLoading(true);
         const token = sessionStorage.getItem('token');
         const tokenOBJ = jwtDecode(token);
         if (tokenOBJ.role === 'Super Admin' || tokenOBJ.role === 'Admin') {
            setIsSuperAdmin(true);
         } else {
            setIsSuperAdmin(false);
         }
      }, 2000);
   }, []);
   //=============================================

   if (!loading) {
      return <Loading styles={'dashboard'} />;
   }
   // if (!isSuperAdmin) {
   return (
      <Paper style={myContainerStyle.root}>
         <Box
            display={'flex'}
            alignContent={'center'}
            justifyContent={'center'}
            m={1}
         >
            <Manual />
         </Box>
         <Box>
            <Box
               display={'flex'}
               alignContent={'center'}
               justifyContent={'center'}
               className={'focus-in-contract'}
               color='primary'
            >
               GSB Way Point
            </Box>
         </Box>
         {/*<Loading styles={'welcome'} />*/}
      </Paper>
   );
   // }
   // return (
   //   <Paper style={myContainerStyle.root}>
   //     <Box
   //       display={'flex'}
   //       alignContent={'center'}
   //       justifyContent={'center'}
   //       m={1}
   //     >
   //       <Manual />
   //     </Box>
   //     <Divider />
   //     <Box display="flex" my={1} alignItems="center">
   //       <Box mx={1}>
   //         <Typography variant="h5">Dashboard</Typography>
   //       </Box>
   //     </Box>
   //     <Box>
   //       <DashboardComparePoint />
   //     </Box>
   //     <Box display={'flex'}>
   //       <Box width={3 / 4}>
   //         <DashBoardFrequencyGiveRedeem />
   //       </Box>
   //       <Box width={1 / 4}>
   //         <DashboardComparePointCircle />
   //       </Box>
   //     </Box>
   //     <Box>
   //       <DashboardOverviewPoint />
   //     </Box>
   //   </Paper>
   // );
}
